<template>
  <BaseVeeForm :action="submit">
    <!-- formProps
      isIdle, isPending, isResolved, isRejected, invalid
      errors, submit
    -->
    <template #default="formProps">
      <BaseCard class="max-w-lg w-full mx-auto">
        <BaseCardHeader>
          <h3 class="text-base font-medium">New Sms message</h3>
        </BaseCardHeader>
        <BaseCardBody>
          <BaseFormTextareaFieldWithValidator
            v-model="data.content"
            :validator="{
              name: 'content',
              vid: 'content',
              rules: {
                required: true,
              },
            }"
            :field="{
              label: 'Message content',
              id: 'content',
            }"
            :disabled="formProps.isPending"
            class="max-w-lg"
          />
          <BaseFormInlineMessage info>
            Message Length: {{ totalChars }}, Total messages: {{ totalMessages }}
          </BaseFormInlineMessage>
        </BaseCardBody>
        <BaseCardFooter gray>
          <BaseButton primary :disable="formProps.isPending"> Create </BaseButton>
        </BaseCardFooter>
      </BaseCard>
    </template>
  </BaseVeeForm>
</template>

<script>
import { pipelineStageSmsMessagesClient } from '@/api/clients';

export default {
  props: {
    pipelineStageId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      data: {
        content: '',
      },
    };
  },
  computed: {
    totalChars() {
      return this.data.content.length;
    },
    totalMessages() {
      return Math.ceil(this.totalChars / 70);
    },
  },
  methods: {
    submit() {
      return pipelineStageSmsMessagesClient
        .store(this.pipelineStageId, this.data)
        .then((response) => {
          this.$emit('sms-message:created', response.data);

          return Promise.resolve(response);
        });
    },
  },
};
</script>
